import { useState } from "react";
import { motion } from "framer-motion";
import { IoIosArrowDown,IoIosArrowForward } from "react-icons/io";
import { NavLink, Link, useLocation,useNavigate } from "react-router-dom";
import { fontSize, style } from "@mui/system";
import { RiBold } from "react-icons/ri";


const SubMenu = ({ data }) => {
    const { pathname } = useLocation();
    const [subMenuOpen, setSubMenuOpen] = useState(false);
    let location = useLocation();
    const navigate = useNavigate();

    const getUrl = (e) => {
        document.getElementById("menu_title").innerHTML = e;
    }

    const toComponentNavigate=(url,newVal,editVal,deleteVal,viewVal)=>{
      debugger;
        navigate(`/${url}`,{state:{NewElg:newVal,EditElg:editVal,DeleteElg:deleteVal,ViewElg:viewVal}});
          }

    return (
      <>
        

                        <li  className={`link ${pathname.includes(data.caption) && "nav-item static-item nav-link static-item disabled"}`}
                                 onClick={() => setSubMenuOpen(!subMenuOpen)}>
                                    <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
                                    <data.icon size={23} className="sub-nav" />
                                        <span className="default-icon">{data.caption}</span>
                                        <span className="mini-icon">-</span>
                                        <IoIosArrowDown
                                            className={` ${subMenuOpen && "rotate-180" } duration-200 ` } 
                                            style={{ fontSize: 18,fontFamily:RiBold }}
                                            
                                        />
                                    </Link>
                                </li>
        <motion.ul
          animate={
            subMenuOpen
              ? {
                  height: "fit-content",
                }
              : {
                  height: 0,
                }
          }
          className="flex h-0 flex-col pl-14 text-[0.8rem] font-normal overflow-hidden"
        >
          {data.menus?.map((menu) => (
           
             
                            // <Link className={`${location.pathname === `/${menu.url}` ? 'active' : ''} nav-link`}
                            //         to={`/${menu.url}`} onClick={() => getUrl(`${menu.caption}`)}>
                            //         <i className="icon">
                            //             <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                            //                 <g>
                            //                     <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                            //                 </g>
                            //             </svg>
                            //         </i>
                            //         <i className="sidenav-mini-icon"> H </i>
                            //         <span className="item-name"> {menu.name} </span>
                            //     </Link>


                            // <Link className={`${location.pathname === `/${menu.url}` ? 'active' : ''} nav-link`}
                            //         to={
                            //             {
                            //                 pathname:  `/${menu.url}`, 
                            //                 state: {New: false, Edit: false, Delete: false,View:false}

                            //             }
                                                                               
                            //             } onClick={() => getUrl(`${menu.caption}`)}>
                            //         <i className="icon">
                            //             <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                            //                 <g>
                            //                     <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                            //                 </g>
                            //             </svg>
                            //         </i>
                            //         <i className="sidenav-mini-icon"> H </i>
                            //         <span className="item-name"> {menu.name} </span>
                            //     </Link>

                            <a className={`${location.pathname === `/${menu.url}` ? 'active' : ''} nav-link`}
                            onClick={() => {
                                toComponentNavigate(`${menu.url}`,menu.NewVal,menu.EditVal,menu.DeleteVal,menu.ViewVal);
                                getUrl(`${menu.caption}`)
                            }}>
                            <i className="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" viewBox="0 0 24 24" fill="currentColor">
                                    <g>
                                        <circle cx="12" cy="12" r="8" fill="currentColor"></circle>
                                    </g>
                                </svg>
                            </i>
                            <i className="sidenav-mini-icon"> H </i>
                            <span className="item-name"> {menu.caption} </span>
                        </a>

                            



           
          ))}
        </motion.ul>
      </>
    );
  };
  
  export default SubMenu;
  